module.exports = __webpack_public_path__ + "img/money.3f24b34b.svg";